export default __webpack_public_path__ + "static/media/training-tour1.06a8f3e9.svg";